import { useRef } from 'react';
import { PressCarousel} from '../ui/PressCarousel';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';



const AboutPress = ({title, subtitle,  items}) => {

    const sectionRef= useRef(null)
    const titleRef= useRef(null)
    const textRef= useRef(null)
    const containerRef = useRef(null)

    useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

      gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 60%",  
          scrub: 0.1,  
        },
      });

      if (titleRef.current) {
        gsap.fromTo(titleRef.current, { opacity: 0 }, {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
          },
        });
      }

      if (textRef.current) {
        gsap.fromTo(textRef.current, { opacity: 0 }, {
          opacity: 1,
          duration: 1,
          delay: 0.2,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
          },
        });
      }

    });

    return () => mm.revert();
  }, {scope: sectionRef, dependencies: items});


    return (
        <section ref={sectionRef} className='container-max pb-[4rem] md:pb-[6rem] lg:pb-[8rem] xl:pb-[10rem] pt-[6rem] md:pt-[10rem] lg:pt-[12rem] xl:pt-[14rem]'>
          <div className='' ref={containerRef}>


            <div className='container-padding mb-[2.4rem] md:mb-[2.8rem] lg:mb-[3.6rem] xl:mb-[5.6rem]'>
                <h2 ref={titleRef} className='mb-[1.6rem] heading-3 [&>.selected]:italic [&>.selected]:text-dusty-green-dark' dangerouslySetInnerHTML={{__html: title}}/>
                <p ref={textRef} className='text-1 max-w-[46rem] lg:max-w-[37rem]'>{subtitle}</p>
            </div>
            <PressCarousel items={items}/>
          </div>
        </section>
    );
};

export default AboutPress;